import React from 'react'
import { graphql } from 'gatsby'
import Center from '../components/templates/Center'
import addNativeReviewsCountToCenter from '../domain/useCases/center/addNativeReviewsCountToCenter'
const center = (props) => {
  const centerProps = {
    ...props,
    center: addNativeReviewsCountToCenter(
      props.data.doc,
      props.data.reviews.edges.map((r) => r.node)
    ),
    locationData: {
      ...props.data.location
    },
    reviews: props.data.reviews.edges,
    ourCenters: props.data.ourCenters.edges,
    ignorePpv: false,
    isCenterPath: false,
    locationAllowList: props.data.locationAllowList.allowedLocations,
    departments: props.pageContext.departments
  }

  return <Center {...centerProps} />
}

export default center

export const query = graphql`
  query Center($title: String, $country: String, $our_centers: [String]) {
    reviews: allReview(filter: { center: { eq: $title } }) {
      edges {
        node {
          _center {
            locations
            slides
            what_we_treat
            slug
            new_specializations
          }
          overall_star
          reviewer_type
          gender
          submit_date(formatString: "MMMM Do, YYYY")
          name
          review_body
          agreement
          recommend
          food_rating
          conditions_treated
          stay_length
          accommodation_rating
          value_rating
          response
          treatment_rating
          pros
          cons
          location
          occupation
          year
          center
          id
        }
      }
    }
    location: location(slug: { eq: $country }) {
      title
      type
      address_parts {
        title
        type
      }
      geo {
        types
        address_components {
          long_name
        }
      }
    }
    doc: center(title: { eq: $title }) {
      pid
      site
      _geoloc {
        lat
        lng
      }
      virtual_tour_embed
      accepted_insurance
      insurance_description
      verify_insurance_link
      what_we_treat
      aftercare
      arranged_aftercare
      faqs {
        answer
        centerId
        id
        question
      }
      included_aftercare
      claimed_email
      sponsor_tier
      locations
      _new_specializations {
        tooltip_description
        tooltip_link
        title
        slug
        type
      }
      _what_we_treat {
        tooltip_description
        tooltip_link
        title
      }
      _arranged_aftercare {
        tooltip_description
        tooltip_link
        title
      }
      _off_site_activities {
        tooltip_description
        tooltip_link
        title
      }
      _who_we_treat {
        tooltip_description
        tooltip_link
        title
      }
      _amenities {
        tooltip_description
        tooltip_link
        title
      }
      _onsite_activities {
        tooltip_description
        tooltip_link
        title
      }
      _special_considerations {
        tooltip_description
        tooltip_link
        title
      }
      _included_aftercare {
        tooltip_description
        tooltip_link
        title
      }
      _treatment_therapies {
        tooltip_description
        tooltip_link
        title
      }
      _treatment_services {
        tooltip_description
        tooltip_link
        title
      }
      _insurance_info {
        tooltipDescription
        tooltipLink
        insurance_logo
        slug
        title
      }
      _locations {
        title
        slug
        type
        isDma
        dmaId
        geo {
          types
        }
        _related_locations {
          title
          slug
        }
      }
      providerType
      _treatment_method {
        tooltip_description
        tooltip_link
        title
      }
      specializations
      title
      pricing_label
      slides
      featured_image
      status
      location_label
      slug
      email
      verified_description
      card_size
      length_label
      highlights
      short_description
      price_label
      price
      setting
      phone
      phone_numbers {
        label
        number
      }
      primary_cta
      logo
      website
      amenities
      accredidation
      youtube
      twitter
      facebook
      video_embed
      template
      long_description
      testimonial_background
      address
      location_query
      descriptions {
        full
        short
      }
      testimonials {
        content
        name
      }
      news {
        title
        description
        link
      }
      treatment_method
      team_members {
        position
        qualifications
        name
        image
      }
      text_picture {
        image
        content
        background
        title
        link
      }
      listing_template
      header_image
      occupancy
      founded_date
      treatment_services
      treatment_therapies
      special_considerations
      certifications {
        url
        label
        image
      }
      new_specializations
      price_length {
        price
        length
      }
      accredidation
      new_locations {
        type
        title
        slug
      }
      benefitsKey
      benefitsProvider
      occupancy
      languages
      who_we_treat
      activities
      br
      onsite_activities
      off_site_activities
      onsite_amenities
      personal_amenities
      off_amenities
      business_contact
      analytics_dashboard
      our_centers_header
      furtherAiEnabled
      _third_party_reviews {
        center_id
        platform
        provider
        provider_id
        review_count
        rating
      }
      primaryFocus
    }
    locationAllowList: locationAllowList {
      allowedLocations {
        center_count
        slug
        title
        location_id
      }
    }
    ourCenters: allCenter(filter: { title: { in: $our_centers } }) {
      edges {
        node {
          type
          title
          slug
          treatment_method
          location_label
          setting
          short_description
          featured_image
          sponsor_tier
        }
      }
    }
  }
`
